import React, { useState, useEffect } from "react";
import DataTable from "../components/DataTable";
import SnackbarAlert from "../components/SnackbarAlert";
import { Box, TextField, IconButton, Tooltip, Typography, Button, CircularProgress, Dialog, DialogTitle, DialogContent, DialogActions, MenuItem, } from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";
import AddIcon from "@mui/icons-material/Add";
import { webEndPoint } from '../constants/globalConstants';
import { makeRequest } from "../services/api";
export default function ShippingCharges() {
    const [districts, setDistricts] = useState([]);
    const [search, setSearch] = useState("");
    const [openModal, setOpenModal] = useState(false);
    const [selectedState, setSelectedState] = useState("");
    const [selectedCategory, setSelectedCategory] = useState("");
    const [states, setStates] = useState([]);
    const [category, setCategory] = useState([]);
    const [editShipping, setEditShipping] = useState(null);
    const [noofPieces, setNoofPieces] = useState("");
    const [charges, setCharges] = useState("");
    const [snackbar, setSnackbar] = useState(false);
    const [message, setMessage] = useState("");
    const [loading, setLoading] = useState(false);
    useEffect(() => {
        fetchData();
        fetchstates();
    }, []);
    const fetchstates = async () => {
        setLoading(true);
        try {
            let url = webEndPoint + "courier";
            const response = await makeRequest("get", url);
            if (response) {
                setStates(response?.data);
                setLoading(false);
            }
        } catch (err) {
            console.error(err);
        } finally {
            setLoading(false);
        }
        setLoading(true);
        try {
            let url = webEndPoint + "maincategories";
            const response = await makeRequest("get", url);
            if (response) {
                setCategory(response?.data);
                setLoading(false);
            }
        } catch (err) {
            console.error(err);
        } finally {
            setLoading(false);
        }
    };
    const fetchData = async () => {
        setLoading(true);
        try {
            let url = webEndPoint + "shipping-charges";
            const response = await makeRequest("get", url);
            if (response) {
                setDistricts(response?.data);
                setLoading(false);
            }
        } catch (err) {
            console.error(err);
        } finally {
            setLoading(false);
        }
    };
    const openAddModal = () => {
        setEditShipping(null);
        setSelectedState("");
        setSelectedCategory("");
        setNoofPieces("");
        setCharges("");
        setOpenModal(true);
    };
    const handleEdit = (shipping) => {
        setEditShipping(shipping);
        setSelectedState(shipping.maincategory_id);
        setSelectedCategory(shipping.courier_id);
        setNoofPieces(shipping.number_of_pieces);
        setCharges(shipping.charges);
        setSelectedState(shipping.courier_id);
        setSelectedCategory(shipping.maincategory_id);
        setOpenModal(true);
    };
    const handleSave = async () => {
        if (!noofPieces && !charges && !selectedCategory && !selectedState) {
            setMessage("All fileds are required");
            setSnackbar(true);
            return;
        }
        setLoading(true);
        try {
            if (editShipping) {
                const stateEditData = {
                    maincategory_id: selectedCategory,
                    courier_id: selectedState,
                    number_of_pieces: noofPieces,
                    charges: charges
                };
                try {
                    let url = webEndPoint + "shipping-charges/" + editShipping?.rfId;
                    const response = await makeRequest("put", url, stateEditData);
                    if (response) {
                        setLoading(false);
                        setMessage("Shipping Charges Updated Successfully");
                    }
                } catch (err) {
                    if (err?.message) {
                        setMessage(err.message);
                    } else {
                        setMessage("Something went wrong");
                    }
                } finally {
                    setLoading(false);
                }
            } else {
                const districtAddData = {
                    maincategory_id: selectedCategory,
                    courier_id: selectedState,
                    number_of_pieces: noofPieces,
                    charges: charges
                };
                try {
                    let url = webEndPoint + "shipping-charges";
                    const response = await makeRequest("post", url, districtAddData);
                    if (response) {
                        setLoading(false);
                        setMessage("Shipping Charges Added Successfully");
                    }
                } catch (err) {
                    if (err?.message) {
                        setMessage(err.message);
                    } else {
                        setMessage("Something went wrong");
                    }
                } finally {
                    setLoading(false);
                }
            }
            fetchData();
            setSnackbar(true);
            setOpenModal(false);
        } catch (err) {
            console.error(err);
        } finally {
            setLoading(false);
        }
    };
    const filteredDistricts = districts?.filter((d) =>
        d?.courier_name?.toLowerCase().includes(search?.toLowerCase())
    );
    const columns = ["S.No", "Courier Name ", "Main Category Name", "No of Pieces", "Charges", "Action"];
    const rows = filteredDistricts?.map((shipping, index) => [index + 1, shipping.courier_name, shipping.maincategory_name, shipping.number_of_pieces, shipping.charges,
    <Box>
        <Tooltip title="Edit Shipping Charges">
            <IconButton color="primary" onClick={() => handleEdit(shipping)}>
                <EditIcon />
            </IconButton>
        </Tooltip>
    </Box>
    ]);
    return (
        <Box sx={{ position: "relative" }}>
            {loading && (
                <Box sx={{ position: "fixed", top: 0, left: 0, width: "100vw", height: "100vh", backgroundColor: "rgba(255,255,255,0.6)", display: "flex", justifyContent: "center", alignItems: "center", zIndex: 9999, }}>
                    <CircularProgress />
                </Box>
            )}
            <Typography variant="h6" sx={{ mb: 3, fontWeight: 500 }}>Shipping Charges</Typography>
            <Box sx={{ display: "flex", flexDirection: { xs: "column", sm: "row" }, gap: 2, alignItems: { xs: "stretch", sm: "center" }, justifyContent: "space-between", mb: 2, width: "100%", }}>
                <TextField label="Search Courier Name" size="small" value={search} onChange={(e) => setSearch(e.target.value)} sx={{ width: { xs: "100%", sm: "70%", md: 600 } }} />
                <Button variant="contained" startIcon={<AddIcon />} onClick={openAddModal} sx={{ width: { xs: "100%", sm: "auto" }, }}>Add Shipping Charges</Button>
            </Box>
            <DataTable columns={columns} rows={rows} />
            <SnackbarAlert open={snackbar} setOpen={setSnackbar} message={message} />
            <Dialog open={openModal} onClose={() => setOpenModal(false)} fullWidth maxWidth="sm">
                <DialogTitle>{editShipping ? "Edit Shipping Charges" : "Add Shipping Charges"}</DialogTitle>
                <DialogContent sx={{ display: "flex", flexDirection: "column", gap: 2, mt: 1 }}>
                    <TextField select label="Select Courier" value={selectedState} onChange={(e) => setSelectedState(e.target.value)} sx={{ mt: 2 }} fullWidth>
                        {states.map((state) => (
                            <MenuItem key={state.rfId} value={state.rfId}>{state.courier_name}</MenuItem>
                        ))}
                    </TextField>
                    <TextField select label="Select Main Category" value={selectedCategory} onChange={(e) => setSelectedCategory(e.target.value)} sx={{ mt: 2 }} fullWidth>
                        {category.map((state) => (
                            <MenuItem key={state.rfId} value={state.rfId}>{state.maincategory_name}</MenuItem>
                        ))}
                    </TextField>
                    <TextField label="No of Pieces" value={noofPieces} onChange={(e) => {
                        const value = e.target.value; if (/^\d*\.?\d*$/.test(value)) { setNoofPieces(value); }
                    }} sx={{ mt: 2 }} fullWidth />
                    <TextField label="Charges" value={charges} onChange={(e) => {
                        const value = e.target.value; if (/^\d*\.?\d*$/.test(value)) { setCharges(value); }
                    }} sx={{ mt: 2 }} fullWidth />
                </DialogContent>
                <DialogActions>
                    <Button onClick={() => setOpenModal(false)}>Cancel</Button>
                    <Button variant="contained" onClick={handleSave}>{editShipping ? "Update" : "Save"}</Button>
                </DialogActions>
            </Dialog>
        </Box>
    );
}